import { Paper } from "@trackman/web-shared-components";
import AppUseIcon from "./AppUseIcon";

const AppInfoFrame = ({
                        message,
                        className
                      }: {
  message: string;
  className?: string;
}) => {
  return (<Paper variant='outlined' color='lightGrey' className={`d-flex flex-row align-items-center px-3 py-2-5 ${className}`}>
    <AppUseIcon name='InfoIcon' color='#7B7B7B' className='mr-2-5' width='16' height='17' />
    <div className='flex-grow-1 font-lato font-13 font-400 color-darkGrey'>{message}</div>
  </Paper>)
}

export default AppInfoFrame;